import * as React from 'react';
import { ContactInfo, LeaseMatchResult, LeaseMatchType } from '../../../../api/Property';

const ContactInfoMatch = (props: { contactInfo: ContactInfo }) => (
    <>
        <td>
            <div style={{ overflowWrap: 'anywhere' }}>
                {props.contactInfo.firstName} {props.contactInfo.lastName}
            </div>
        </td>
        <td>
            <div style={{ overflowWrap: 'anywhere' }}>{props.contactInfo.email}</div>
        </td>
    </>
);

const LeaseMatchRow = (props: {
    match: LeaseMatchResult;
    checked?: boolean;
    setChecked?: (checked: boolean) => void;
}) => (
    <tr
        className={
            props.match.matchType === LeaseMatchType.Exact
                ? 'success-row'
                : props.match.matchType === LeaseMatchType.Possible
                ? 'possible-row'
                : 'no-match-row'
        }
    >
        <ContactInfoMatch contactInfo={props.match.submittedData} />
        <ContactInfoMatch
            contactInfo={
                props.match.matchedData || { firstName: 'Not', lastName: 'Matched', email: 'N/A' }
            }
        />

        <td>
            {/* put a div inside the <td> to force max width (wrap any extra text) */}
            {props.setChecked && props.match.matchType !== LeaseMatchType.Unmatched ? (
                <div>
                    <input
                        type="checkbox"
                        checked={props.checked}
                        onChange={() => props.setChecked && props.setChecked(!props.checked)}
                    />
                </div>
            ) : (
                'N/A'
            )}
        </td>
    </tr>
);

export default LeaseMatchRow;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/LeaseMatchRow.tsx